// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 507px) {
  .tabeladmin {
    margin-top: 15px;
  }

  .tablenamaadmin {
    text-align: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media only screen and (max-width: 507px) {\n  .tabeladmin {\n    margin-top: 15px;\n  }\n\n  .tablenamaadmin {\n    text-align: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
